import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Facilityemployees from './components/Facilityemployees';

const facilityemployees = (props,{ t }) => (
  <Container>
    <Facilityemployees {...props} />
  </Container>
);

facilityemployees.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(facilityemployees);
